






































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
// import Employment from "@/zh-website/src/views/Colleges/profession/Employment.vue";
import { CollegesService } from "@/zh-website/src/views/Colleges/service";
/**
 * 人工智能
 */
// 就业指导
import Employment from "./components/Employment.vue";
// 实训室建设
import Experiment from "./components/Experiment.vue";
// 建设思路
import Ideas from "./components/Ideas.vue";
// “三教”实践
import Practice from "./components/Practice.vue";
/**
 * 物联网
 */
// 建设思路
import IdeasNetworkCase from "./NetworkCase/Ideas.vue";
// 实训室建设
import ExperimentNetworkCase from "./NetworkCase/Experiment.vue";
// “三教”实践
import PracticeNetworkCase from "./NetworkCase/Practice.vue";
// 专业认证
// import ProfessionalCertification from "./Case/ProfessionalCertification";
// 就业指导
import EmploymentNetworkCase from "./NetworkCase/Employment.vue";
/**
 * 大数据
 */
// 建设思路
import IdeasBigDataCase from "./BigDataCase/Ideas.vue";
// 实训室建设
import ExperimentBigDataCase from "./BigDataCase/Experiment.vue";
// “三教”实践
import PracticeBigDataCase from "./BigDataCase/Practice.vue";
// 专业认证
// import ProfessionalCertification from "./Case/ProfessionalCertification";
// 就业指导
import EmploymentBigDataCase from "./BigDataCase/Employment.vue";
import Cidea from "../componts/communication/Cidea.vue";
import Cconstruction from "../componts/communication/Cconstruction.vue";
import Cpractice from "../componts/communication/Cpractice.vue";
import Cguidance from "../componts/communication/Cguidance.vue";
import Cloudidea from "../componts/cloud/Cidea.vue";
import Cloudconstruction from "../componts/cloud/Cconstruction.vue";
import Cloudpractice from "../componts/cloud/Cpractice.vue";
import Cloudguidance from "../componts/cloud/Cguidance.vue";
@Component({
  components: {
    Banner,
    Employment,
    Experiment,
    Ideas,
    Practice,
    IdeasNetworkCase,
    ExperimentNetworkCase,
    PracticeNetworkCase,
    EmploymentNetworkCase,
    IdeasBigDataCase,
    ExperimentBigDataCase,
    PracticeBigDataCase,
    EmploymentBigDataCase,
    Cidea,
    Cconstruction,
    Cpractice,
    Cguidance,
    Cloudidea,
    Cloudconstruction,
    Cloudpractice,
    Cloudguidance
  }
})
export default class Index extends Vue {
  dom;
  solution = "";
  isFixed = false;
  offsetTop = 0;
  // 选中的项
  activeIndex = 0;
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("../../../assets/Cloud_1.jpg")})`,
      height: "494px"
    },

    // font1: "云计算专业建设",
    font2: "",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  tabs = [
    {
      title: "建设思路",
      content: ""
    },
    {
      title: "实训室建设",
      content: ""
    },
    {
      title: "“三教”实践",
      content: ""
    },
    {
      title: "就业指导",
      content: []
    }
  ];
  staticMatchList = [
    {
      host: "https://www.zj-huawei.com",
      ids: {
        rgzn: "1713844852144173058",
        wlw: "1713844646537203714",
        dsj: "1713843406969376770",
        ydtx: "1713844142455353345",
        yjs: "1713127310740123650"
      }
    },
    {
      host: "https://icsl-h5.zj-huawei.com",
      ids: {
        rgzn: "1713844852144173058",
        wlw: "1713844646537203714",
        dsj: "1713843406969376770",
        ydtx: "1713844142455353345",
        yjs: "1713127310740123650"
      }
    },
    {
      host: "https://icsl-pc.zj-huawei.com",
      ids: {
        rgzn: "1713844852144173058",
        wlw: "1713844646537203714",
        dsj: "1713843406969376770",
        ydtx: "1713844142455353345",
        yjs: "1713127310740123650"
      }
    },
    {
      host: "https://test-pc.zj-huawei.com",
      ids: { rgzn: "", wlw: "", dsj: "", ydtx: "", yjs: "" }
    },
    {
      host: "https://dev-pc.zj-huawei.com",
      ids: { rgzn: "", wlw: "", dsj: "", ydtx: "", yjs: "" }
    }
  ];
  currentStaticIds: any = {
    rgzn: "1713844852144173058",
    wlw: "1713844646537203714",
    dsj: "1713843406969376770",
    ydtx: "1713844142455353345",
    yjs: "1713127310740123650"
  };
  @Watch("$route", { immediate: true })
  onRouteChange() {
    // 专业的id变化  重新请求接口
    // this.currentStaticIds = this.staticMatchList.find(item => {
    //   return item.host == window.location.origin;
    // })?.ids;
    this.getSolutionDetail();
  }
  mounted() {
    // handleScroll为页面滚动的监听回调
    // this.currentStaticIds = this.staticMatchList.find(item => {
    //   return item.host == window.location.origin;
    // })?.ids;
    window.addEventListener("scroll", this.handleScroll);
    this.dom = document.querySelector("#bar");
    this.getSolutionDetail();
  }
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  isIE() {
    //ie?
    if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
    else return false;
  }
  getSolutionDetail() {
    CollegesService.getProductSolutionDetail({
      majorId: this.$route.params.id
    }).then((res: any) => {
      // console.log(res);
      this.list.style["background-image"] = `url(${res.data.resourceUrl})`;
      this.solution = res.data.name;
      res.data.majorSolutionList.forEach((item: any, index: number) => {
        this.tabs[index].content = item.content;
      });
      this.tabs[3].content = res.data.careersGuidanceList;
    });
  }
  // 鼠标hover事件
  changeMask(e) {
    // console.log(e);
    this.activeIndex = e;
    // 判断当前tab有没有吸顶
    if (this.isFixed) {
      if (this.isIE()) {
        // console.log("ie内核");
        document.documentElement.scrollTop = this.offsetTop;
      } else {
        this.$nextTick(() => {
          // console.log("谷歌");
          window.scrollTo({
            top: this.offsetTop,
            behavior: "smooth"
          });
        });
      }
    }
  }
  handleScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.offsetTop = this.dom.offsetTop;
    this.isFixed = scrollTop > this.offsetTop ? true : false;
  }
}
